export const FOCUSED_ITEM_ALPHA = 1;

export const UNFOCUSED_ITEM_ALPHA = 0.3;

export const getInitialStyle = () => ({
  flex: { direction: 'row', alignItems: 'center' },
});
